<template>
  <div class="is-flex">
    <h3 class="title is-6">Stored Card</h3>
    <p class="subtitle is-6" v-if="subscription.last4">
      <b-icon
        :icon="brandIcon.icon"
        :pack="brandIcon.pack"
        v-if="brandIcon"></b-icon>
      ••••{{ subscription.last4 }}
    </p>
    <p class="subtitle is-6" v-else>
      You have no card on file. Your premium subscription will end on {{subscriptionEnd}}.
    </p>
    <router-link
      class="button is-primary is-rounded"
      :to="{ name: 'Upgrade' }"
      v-if="!subscription.last4"
    >
      Add a Card
    </router-link>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'StoredCard',
  props: ['subscription'],
  computed: {
    brandIcon() {
      const pack = 'fab'

      switch (this.subscription.brand.toLowerCase()) {
        case 'american express':
          return { icon: 'cc-amex', pack }
        case 'diners club':
          return { icon: 'cc-diners-club', pack }
        case 'discover':
          return { icon: 'cc-discover', pack }
        case 'jcb':
          return { icon: 'cc-jcb', pack }
        case 'mastercard':
          return { icon: 'cc-mastercard', pack }
        case 'unknown':
        case 'unionpay':
          return { icon: 'credit-card', pack: 'far' }
        case 'visa':
          return { icon: 'cc-visa', pack }
        default:
          return null
      }
    },
    subscriptionEnd() {
      return moment.unix(this.subscription.discountEnd || this.subscription.trialEnd).format('MMMM Do')
    }
  },
};
</script>

<style scoped lang="scss">
.is-flex {
  align-items: flex-start;
  flex-direction: column;

  .button {
    align-self: flex-end;
  }
}
</style>
